import { IMenuOption } from '../models/index';
import { environment } from '../../environments/environment';

export enum CONFIG_TYPE {
  PurchaseOrder = "OPOR",
  PurchaseRequest = "OPRQ"
}

export enum ALERTS {
  success = 1,
  error = 2,
  warning = 3,
  info = 4,
}   

export class AppConstants {
  // CONFIGURACION DEL API: se define por ambiente en src/environments/environment*.ts
  // (dev: coaltapidev, test: coaltapitest, prod: coaltapi, local: localhost:50050)
  static API_URL: string = environment.apiUrl;

  public static get GetMenu(): IMenuOption[] { return this.MENU };

  public static GetPermissionType(_type: number): string {
    let type = '';

    switch (_type) {
      case 0: {
        type = 'Lectura';
        break;
      }
      case 1: {
        type = 'Modificación';
        break;
      }
    }

    return type;
  }

  private static MENU = [
    {
      Name: 'Inicio',
      Route: '/home',
      Icon: 'fa fa-home',
      Children: [],
      Selected: true,
      Type: 1,
      RequiredPerm: 'V_Home',
      Visible: true
    },
    /////////////// BITÁCORA ////////////////
    {
      Name: 'Bitácora',
      Route: '/binnacle',
      Icon: 'fa fa-book',
      Children: [],
      Selected: false,
      Type: 2,
      RequiredPerm: 'V_Acc_Bit',
      Visible: true
    },
    /////////////// PREFERENCIALES GENERALES ////////////////
    {
      Name: 'Configuraciones',
      Route: '',
      Icon: 'fa fa-sliders fa-lg title parent-icon',
      Children: [
        {
          Name: 'Notificaciones',
          Route: '/config-notificaciones',
          Icon: 'fa fa-cogs subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_Acc_Not',
          Visible: true
        },
        {
          Name: 'Usuarios',
          Route: '/users',
          Icon: 'fa fa-cogs subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_Acc_Usu',
          Visible: true
        },
        {
          Name: 'Asignaciones',
          Route: '/user-assigns',
          Icon: 'fa fa-key subtitle',
          Children: [],
          Selected: false,
          Type: 2,
          RequiredPerm: 'V_AccAss', 
          Visible: true
        }
      ],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
    {
      Name: 'Salir',
      Route: '/logout',
      Icon: 'fa fa-sign-out fa-lg title parent-icon',
      Children: [],
      Selected: false,
      Type: 1,
      RequiredPerm: '',
      Visible: true
    },
  ];

}
